import { Grid, Typography } from "@mui/material";
import { OLPaper } from "OLPaper";
import { Toggle } from "components/FormControls/Toggle";
import { useMessage } from "hooks/intl";
import { useStyles } from "./TierSetForm.styles";

export const TierSetStatus = () => {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <OLPaper className={classes.OLPaper}>
      <Grid container>
        <Grid item xs={12}>
          <Toggle
            className={classes.marginBottom}
            label={message({ id: "active" })}
            name="active"
            data-test-id="status"
          />
        </Grid>
        <Grid item xs={12}>
          <Typography
            className={`${classes.sectionSubheader} ${classes.boldText}`}
          >
            {message({ id: "tierSetStatusInfo" })}
          </Typography>
        </Grid>
      </Grid>
    </OLPaper>
  );
};
